import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getEnvironment, parseProductReturnUrl } from '@architeia/auth'
import type { ProductReturnTarget } from '@architeia/auth'

/** Comma-separated local product origins (development only), e.g. http://localhost:5173. */
function parseDevOrigins(raw: unknown): string[] {
  if (typeof raw !== 'string') return []
  return raw
    .split(',')
    .map(origin => origin.trim())
    .filter(origin => origin !== '')
}

/**
 * KORA-114: the validated "Back to <product>" target carried by `/profile?return=<url>` from the
 * shared account menu. Held in memory for the tab; it survives the login round-trip because the
 * whole `?return=` rides inside `redirect` -> `appState.targetUrl`.
 */
export const useAccountReturnStore = defineStore('accountReturn', () => {
  const target = ref<ProductReturnTarget | null>(null)

  function capture(raw: unknown): void {
    target.value = parseProductReturnUrl(raw, {
      env: getEnvironment(),
      selfOrigin: window.location.origin,
      devOrigins: parseDevOrigins(import.meta.env.VITE_ACCOUNT_RETURN_DEV_ORIGINS)
    })
  }

  return { target, capture }
})
